/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ExteriorFacadeConditionEnum = 1 | 2 | 3;

export const ExteriorFacadeConditionEnum = {
    NUMBER_1: 1 as ExteriorFacadeConditionEnum,
    NUMBER_2: 2 as ExteriorFacadeConditionEnum,
    NUMBER_3: 3 as ExteriorFacadeConditionEnum
};

